import { useMutation } from "@apollo/client";

import { GqlMedia } from "~/__generated__";
import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { MapEditorObservationPanel_ObservationUpdateDocument } from "./mutations.generated";
import { MapEditorObservationPanelValidationStatusDocument } from "./queries.generated";

export interface ObservationUpdateFormValues {
    answers: Record<string, string | null>;
    createdAt: Date;
    feedbackComment: string | null | undefined;
    feedbackRating: boolean | null | undefined;
    medias: GqlMedia[];
    observationTypeId: string;
    preciseLocation: Record<string, string | null>;
    speciesId: string;
}

export function useUpdateObservationMutation() {
    const [mutate, result] = useMutation(MapEditorObservationPanel_ObservationUpdateDocument, {
        refetchQueries: [MapEditorObservationPanelValidationStatusDocument],
    });

    const updateObservation = (observationId: string, { medias, createdAt, ...restProps }: ObservationUpdateFormValues) =>
        mutate({
            variables: {
                input: {
                    ...restProps,
                    createdAt: parseDateToString(createdAt),
                    observationId,
                    mediaIds: medias.map(media => media.id),
                },
            },
        });

    return [updateObservation, result] as const;
}
